import { useQuery } from "@tanstack/react-query";

import { directApplySyncQueryKeys } from "./query-keys";
import { ApplySyncComparisonDto } from "./types";

import { instance } from "@/lib/axios/instance";

export function useApplySyncComparison(
  integrationName: string | undefined,
  clientId: string | undefined,
  from: string,
  to: string
) {
  return useQuery({
    queryKey: directApplySyncQueryKeys.comparison(
      integrationName ?? "",
      clientId ?? "",
      from,
      to
    ),
    queryFn: () =>
      instance
        .get(
          `/api/v2/Integrations/${integrationName}/direct-apply/sync`,
          {
            params: { clientId, from, to },
          }
        )
        .then((res) => {
          const items = (res.data as { data?: ApplySyncComparisonDto[] })?.data ?? [];
          return items[0] ?? null;
        }),
    enabled: !!integrationName && !!clientId,
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000,
  });
}
